<div>
  <div class="container-bienvenida">
    <div class="container-derecho" id="container-img" #containerDerecho>

      <div style="position: relative;  width: 100%;">

        <!-- Vista previa -->
        <div style="position: relative;">
          <!-- <div (click)="expand()"  class="pointer" [innerHTML]="html" ></div>-->
          <div (click)="expand()" class="pointer div-img-expand" *ngIf="isDesktop">

            <img src="./assets/img/posgrado-fichas.png" alt="" class="img-fichas" *ngIf="!datos.image">


            <div [innerHTML]="datos.image" *ngIf="datos.image"></div>
          </div>
          <div class="pointer div-img-expand mt-2" *ngIf="!isDesktop">
            <div [innerHTML]="datos.image" *ngIf="datos.image"></div>
            <img src="./assets/img/posgrado-fichas-mobile.jpg" alt="" class="img-fichas" *ngIf="!datos.image">
          </div>
          <!--<button (click)="expand()" class="expand-btn" aria-label="Expandir contenido" *ngIf="isDesktop">
            <img src="./assets/img/arrows_output.png" alt="expandir">
          </button>-->

          <img (click)="expand()" class="expand-icon" src="./assets/img/icon-expandir-blanco.png" alt="expandir"
            *ngIf="isDesktop">
        </div>

        <!-- Modal de pantalla completa -->
        <div class="html-modal" *ngIf="isModalOpen">
          <div class="html-content-wrapper" (wheel)="zoom($event)" (mousedown)="startDrag($event)"
            (mousemove)="onDrag($event)" (mouseup)="endDrag()" (mouseleave)="endDrag()" [ngStyle]="{
         'transform': 'scale(' + scale + ') translate(' + translateX + 'px,' + translateY + 'px)',
         'cursor': isDragging ? 'grabbing' : 'grab'
       }">
            <!-- <div [innerHTML]="html"></div> -->
            <div class="pointer " [innerHTML]="datos.image">
              <!-- <img src="./assets/img/posgrado-fichas.png" alt=""> -->
            </div>
            <img src="./assets/img/posgrado-fichas.png" alt="" class="img-fichas" *ngIf="!datos.image">
          </div>

          <button class="close-btn2" (click)="close(); $event.stopPropagation()">x</button>
        </div>
      </div>

    </div>

    <div class="img-container" id="container-info" #imgContainer>


      <div class="datosCursada">
        <div>
          <img class='icon-cursada' src="./assets/img/icon-calnedario-fichas.png">
        </div>
        <div style="margin-left: 20px;">
          <div>
            <span class="nunito-bold text1">Inicio:</span><span
              class="nunito-medium ml-2">{{datos.date_search_start}}</span>
          </div>
          <div *ngIf="datos.date_ending">
            <span class="nunito-bold text1">Finalización:</span><span
              class="nunito-medium ml-2 ">{{datos.date_ending}}</span>
          </div>
        </div>
      </div>
      <div class="datosCursada" *ngIf="datos.coursed">
        <div>
          <img class='icon-cursada' src="./assets/img/icon-cursada-fichas.png">
        </div>
        <div style="margin-left: 20px;">
          <div>
            <span class="nunito-bold text1">Cursada:</span><span class="nunito-medium ml-2 ">{{datos.coursed}}</span>
          </div>
        </div>
      </div>
      <div class="datosCursada" *ngIf="datos.modality">
        <div>
          <img class='icon-cursada' src="./assets/img/icon-modalidad-fichas.png">
        </div>
        <div style="margin-left: 20px;">
          <div>
            <span class="nunito-bold text1">Modalidad:</span><span class="nunito-medium ml-2 ">{{datos.modality}}</span>
          </div>
        </div>
      </div>
      <div class="datosCursada" *ngIf="datos.workload">
        <div>
          <img class='icon-cursada' src="./assets/img/icon-duracion-fichas.png">
        </div>
        <div style="margin-left: 20px;">
          <div>
            <span class="nunito-bold text1">Duración:</span><span class="nunito-medium ml-2 ">{{datos.workload}}</span>
          </div>
        </div>
      </div>
      <div class="directorDiv" *ngIf="datos.authority">
        <span class="nunito-bold text1">Autoridad:</span><span class="nunito-medium ml-2 ">{{datos.authority}}</span>
      </div>
      <div class="buttons-aranceles">
        <!--button_signUp_state-->


        <button *ngIf="datos.button_talk_state" class="btn-aranceles2 nunito-medium zoomIn"
          (click)="externalLink(datos?.button_talk)">CHARLAS INFORMATIVAS
        </button>
        <button (click)="openModalConsulta()" *ngIf="datos.button_signUp_state"
          class="btn-aranceles2 nunito-medium zoomIn">QUIERO RECIBIR MÁS INFORMACIÓN
        </button>
        <button *ngIf="datos.button_tariff_state" class="btn-aranceles2 nunito-medium zoomIn"
          (click)="externalLink(datos?.button_tariff)">ARANCELES
        </button>

        <ng-container *ngFor="let btn of datos.buttonStudyPlan">
          <button *ngIf="( !btn.type || btn.type=='boton') && btn.state" (click)="openModal(btn)"
            class="btn-aranceles2 nunito-medium zoomIn">{{btn.title}}</button>
          <button *ngIf="btn.type=='link' && btn.state" (click)="openLink(btn)"
            class="btn-aranceles2 nunito-medium zoomIn">{{btn.title}}</button>
        </ng-container>
        <!--<button class="btn-aranceles2 nunito-medium">CONSULTAR DESCUENTOS Y BENEFICIOS</button>-->
      </div>
      <!--<div class="linea"></div>
      <div class="divIcons">
        <a [href]="datos.whatsapp" Target="_blank">
          <img class=" pointer redes" src="./assets/img/wsp-icon.png" alt="">
        </a>
        <a (click)="openModalConsulta()">
          <img class=" pointer redes" src="./assets/img/msg-icon-posgrado.png" alt="">
        </a>
        <a [href]="datos.facebook" Target="_blank" class="ml-4">
          <img class=" pointer redes" src="./assets/img/fb-icon-posgrado.png" alt="">
        </a>
        <a [href]="datos.instagram" Target="_blank">
          <img class=" pointer redes" src="./assets/img/ig-icon-posgrado.png" alt="">
        </a>

      </div>
      <div class="linea"></div>-->


    </div>
  </div>
</div>